/* tslint:disable:jsx-no-lambda*/
import { MUIButton, Title } from '@abb/arcadia-ui-react';
import { Search } from '@module/shared';
import { IPagingSettings, ISortingSettings } from '@module/shared/components/Site/models';
import { SITE_LIST_SEARCH_PLACEHOLDER } from '@service/constants';
import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from '@module/shared/routerCompat';
import * as ActionCreators from '../actionCreators/siteActionCreators';
import Sites from './Sites';

export class SitesContainer extends React.Component<any, any> {
  public render() {
    const searchServIsButton = (
      <MUIButton variant='primary' size={32} label='Search ServIS'
        onClickButton={() => { this.handleServIsButtonClick(); }} />
    );
    return (
      <div className='container app-content-div'>
        <div>
          <Title textElement={<div className="title">Registered Sites</div>} />
        </div>
        <div className="card-container">
        <div className='row'>
          <div className='col-sm-4 search-container'>
            <Search filter={this.props.searchFilter} applyFilter={this.props.applyFilter} clearFilter={this.props.clearFilter} changeFilterField={this.props.changeFilterField} placeholder={SITE_LIST_SEARCH_PLACEHOLDER}/>
            {searchServIsButton}
          </div>
        </div>
        <div className='row'>
          <div className='col-md-12'>
            <Sites
              sites={this.props.sites}
              sortingSettings={this.props.sortingSettings}
              history={this.props.history}
              sortField={this.props.sortField}
              searchFilter={this.props.searchFilter}
              sitesLoading={this.props.sitesLoading}
              pagingSettings={this.props.pagingSettings}
              totalNumberOfSites={this.props.totalNumberOfSites}
              requestPage={this.props.requestPage}
              requestRowsPerPage={this.props.requestRowsPerPage}
            />
          </div>
        </div>
        </div>
      </div>
    );
  }

  componentDidMount() {
    this.props.requestSitesGet(this.props.pagingSettings, this.props.sortingSettings, this.props.searchFilter, this.props.fromServIs);
  }

  handleServIsButtonClick() {
    this.props.history.push(`/register`);
    this.props.requestServIsPage(0);
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps, mergeProps)(SitesContainer) as any);

export function mapStateToProps(store: { sitesState: any; userState: { loggedInUser: { access_token: string } }; permissionsState: any }) {
  const { access_token: accessToken } = store.userState.loggedInUser;
  return { ...store.sitesState, ...store.userState, ...store.permissionsState, accessToken };
}

function mapDispatchToProps(dispatch: any) {
  return {
    requestSitesGet: (pagingSettings: IPagingSettings, sortingSettings: ISortingSettings, searchFilter: string, fromServIs: boolean, accessToken: string) =>
      dispatch(ActionCreators.onSiteGetRequest(pagingSettings, sortingSettings, searchFilter, fromServIs, accessToken)),
    dispatchPagingChange: (pagingSettings: IPagingSettings, sortingSettings: ISortingSettings, searchFilter: string, fromServIs: boolean, accessToken: string) =>
      dispatch(ActionCreators.onPagingChange(pagingSettings, sortingSettings, searchFilter, fromServIs, accessToken)),
    dispatchServIsPagingChange: (pagingSettings: IPagingSettings, sortingSettings: ISortingSettings, searchFilter: string, fromServIs: boolean, accessToken: string) =>
      dispatch(ActionCreators.onServIsPagingChange(pagingSettings, sortingSettings, searchFilter, fromServIs, accessToken)),
    dispatchSortingChange: (pagingSettings: IPagingSettings, sortingSettings: ISortingSettings, searchFilter: string, fromServIs: boolean, accessToken: string) =>
      dispatch(ActionCreators.onSortingChange(pagingSettings, sortingSettings, searchFilter, fromServIs, accessToken)),
    dispatchApplyFilter: (searchFilter: string, pagingSettings: IPagingSettings, sortingSettings: ISortingSettings, fromServIs: boolean, accessToken: string) =>
      dispatch(ActionCreators.onFilterApplied(searchFilter, pagingSettings, sortingSettings, fromServIs, accessToken)),
    dispatchFilterFieldChange: (searchFilter: string) =>
      dispatch(ActionCreators.onFilterFieldChange(searchFilter))
  };
}

function mergeProps({ accessToken, ...propsFromState }: any, propsFromDispatch: any, ownProps: any) {
  return {
    ...propsFromState,
    ...ownProps,
    requestSitesGet: (pagingSettings: IPagingSettings, sortingSettings: ISortingSettings, searchFilter: string, fromServIs: boolean) =>
      propsFromDispatch.requestSitesGet(pagingSettings, sortingSettings, searchFilter, fromServIs, accessToken),
    requestPage: (skipItems: number) => {
      const newPagingSettings = { ...propsFromState.pagingSettings, skipItems };
      propsFromDispatch.dispatchPagingChange(newPagingSettings, propsFromState.sortingSettings, propsFromState.searchFilter, propsFromState.fromServIs, accessToken);
    },
    requestRowsPerPage: (pageSize: number) => {
      const newPagingSettings = { ...propsFromState.pagingSettings, pageSize, skipItems: 0 };
      propsFromDispatch.dispatchPagingChange(newPagingSettings, propsFromState.sortingSettings, propsFromState.searchFilter, propsFromState.fromServIs, accessToken);
    },
    requestServIsPage: (skipItems: number) => {
      const newPagingSettings = { ...propsFromState.pagingSettings, skipItems };
      propsFromDispatch.dispatchServIsPagingChange(newPagingSettings, propsFromState.sortingSettings, propsFromState.searchFilter, true, accessToken);
    },
    sortField: (sortField: string) => {
      let newSortingSettings: { sortField: string; sortDirection: string } | null = null;
      if (sortField === propsFromState.sortingSettings.sortField) {
        const newDirection = propsFromState.sortingSettings.sortDirection === 'asc' ? 'desc' : 'asc';
        newSortingSettings = { ...propsFromState.sortingSettings, sortDirection: newDirection };
      } else {
        newSortingSettings = { sortField, sortDirection: 'asc' };
      }
      propsFromDispatch.dispatchSortingChange(propsFromState.pagingSettings, newSortingSettings, propsFromState.searchFilter, propsFromState.fromServIs, accessToken);
    },
    applyFilter: (event: any) => {
      event.preventDefault();
      propsFromDispatch.dispatchApplyFilter(propsFromState.searchFilter, propsFromState.pagingSettings, propsFromState.sortingSettings, propsFromState.fromServIs, accessToken);
    },
    clearFilter: () => { propsFromDispatch.dispatchApplyFilter('', propsFromState.pagingSettings, propsFromState.sortingSettings, propsFromState.fromServIs, accessToken); },
    changeFilterField: (event: React.ChangeEvent<any>) => {
      propsFromDispatch.dispatchFilterFieldChange(event.target.value);
    },
    clearSearchField: () => {
      propsFromDispatch.dispatchApplyFilter('', propsFromState.pagingSettings, propsFromState.sortingSettings, propsFromState.fromServIs, accessToken);
    },
    setPermissions: propsFromDispatch.setPermissions
  };
}
